import React from 'react';
import { useApiKey } from '../contexts/ApiKeyContext';
import './ApiKeySection.css';

const ApiKeySection = () => {
  const { 
    apiKey, 
    isConnected, 
    connectionStatus, 
    isValidating,
    connect, 
    disconnect, 
    updateApiKey 
  } = useApiKey();

  const handleConnect = async () => {
    await connect();
  };

  const handleDisconnect = () => {
    disconnect();
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !isConnected && apiKey.trim()) {
      handleConnect();
    }
  };

  return (
    <section className="api-key-section">
      <div className="api-key-container">
        <div className="api-key-card">
          <h2>Connect Your API</h2>
          <p>Enter your OpenAI API key to start exploring</p>
          
          <div className="input-group">
            <input
              type="password"
              placeholder="Enter your ChatGPT API key..."
              value={apiKey}
              onChange={(e) => updateApiKey(e.target.value)}
              onKeyPress={handleKeyPress}
              className="api-key-input"
              disabled={isConnected}
            />
            {!isConnected ? (
              <button 
                onClick={handleConnect}
                className="connect-button"
                disabled={!apiKey.trim() || isValidating}
              >
                {isValidating ? 'Validating...' : 'Connect'}
              </button>
            ) : (
              <button 
                onClick={handleDisconnect}
                className="disconnect-button"
              >
                Disconnect
              </button>
            )}
          </div>
          
          {connectionStatus && (
            <div className={`status-message ${isConnected ? 'success' : 'error'}`}>
              {connectionStatus}
            </div>
          )}
          
          <div className="api-key-info">
            <p>🔒 Your API key is stored locally in cookies and never sent to our servers</p>
            <p>💡 Press Enter to connect quickly</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ApiKeySection; 